module.exports = __webpack_public_path__ + "assets/img/knead_active.c9eb0734.png";